export default "__VITE_ASSET__BxMV2Y8t__"